import QdContainer from 'components/Common/QdContainer'
import React from 'react'
import Header from './Header'
import { Card, CardBody } from 'reactstrap'
import ImportForm from './ImportForm'
import { Provider } from './LocationMapImportContext'

function LocationMapImport() {
    return (
        <Provider>
        <QdContainer>
            <Header />
            <Card className="p-2">
                <CardBody>
                    <ImportForm />

                </CardBody>
            </Card>
        </QdContainer>
        </Provider>
    )
}

export default LocationMapImport